// @flow

import type {TreeStructure} from '../typedef';

export const getAllMatchedIds = (data: TreeStructure): Array<string> =>
    data.reduce((acc, item) => {
        let childrenIds = [];
        let childrenTotal = 0;
        let childrenMatched = 0;
        if (item.children) {
            const children = item.children;
            childrenTotal = children.length;
            childrenIds = getAllMatchedIds(children);
            childrenMatched = children.filter(i => childrenIds.includes(i.id)).length;
        }
        if (item.matchedSearch && (!childrenTotal || childrenTotal === childrenMatched)) {
                acc.push(item.id);
            }
        return acc.concat(childrenIds);
    }, []);
